export function StepDots({ index, steps }) {
  return (
    <div className="flex items-center gap-1.5">
      {steps.map((_, i) => (
        <span
          key={i}
          className={`h-1 w-6 rounded-sm transition-colors ${
            i === index ? "bg-[#CFA66A]" : i < index ? "bg-[#5E7A62]/60" : "bg-[#2E2A25]"
          }`}
        />
      ))}
    </div>
  );
}
